import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DecimalDigits, WalletTypes } from '@constants/enums';
import { Currency } from '../components/common/Form/config';
import { formatCurrency } from '../utils/formater';
import { selectWalletsData } from '../modules/wallets/selectors';

interface UseCurrencyBalanceProps {
  currency: Currency;
}

const useCurrencyBalance = ({ currency }: UseCurrencyBalanceProps) => {
  const walletData = useSelector(selectWalletsData);
  const wallet = useMemo(
    () =>
      walletData?.find(
        (currentCurrency) =>
          currentCurrency.currency.name === currency &&
          currentCurrency.wallet.wallet_type === WalletTypes.GLOBAL_ACCOUNT
      ),
    [walletData, currency]
  );

  return {
    balance: formatCurrency(
      wallet?.balance,
      DecimalDigits.COMPLETE_DIGITS,
      DecimalDigits.DEFAULT_MIN_DIGITS,
      currency
    ),
    defaultCurrency: wallet?.wallet.default_currency,
    wallet: walletData,
  };
};

export default useCurrencyBalance;
